export const LELANG_PACKING = {
  // status.id dari GET lelang-packing/shipment/{batchId}
  SHIPMENT_STATUS: {
    PACKING: 0,
    SELESAI: 1,
    PENGIRIMAN_KE_DROPOFF: 2,
    DITERIMA_DROPOFF: 3,
    DITOLAK_DROPOFF: 4,
  },
}
